var cleanCheckout = {
    init: function() {
        cleanCheckout.payment.stripeScriptPromise = $.ajax({
            url: 'https://js.stripe.com/v3/',
            dataType: 'script',
            cache: true,
        });
        cleanCheckout.initToggleCartItem();
        cleanCheckout.steps.initToggle();
        cleanCheckout.payment.initPayBtnTracking();
        cleanCheckout.payment.checkPaypalAbort();
        cleanCheckout.forms.init();
        cleanCheckout.forms.initDeliveryToggle();
        cleanCheckout.successPage.scrollAnimation();
        setTimeout(() => { // wait for form data to be filled by cookies
            cleanCheckout.payment.initSelect();
        }, 200);
    },
    initToggleCartItem: function() {
        $('.js-toggle-cart-item').click(function(event) {
            event.preventDefault();
            $(this).
                closest('.js-cart-item').
                toggleClass('is-open').
                find('.js-cart-item-content').
                slideToggle('fast');
        });
    },
    steps: {
        initToggle: function() {
            $('.js-toggle-steps').click(function(event) {
                event.preventDefault();
                var step = $(this).attr('data-step');
                if (cleanCheckout.forms.checkStep1() | step != 2) {
                    cleanCheckout.steps.show(step);
                    history.pushState({
                        'step': step,
                    }, '', document.location.pathname + '?step=' + step);
                }
            });

            // Set history state so we can go back later
            var getParams = new URLSearchParams(document.location.search),
                step = 1;
            if (getParams.get('step')) step = getParams.get('step');
            history.replaceState({
                'step': step,
            }, '', document.location.href);

            // History navigation event
            window.onpopstate = function(event) {
                cleanCheckout.steps.show(event.state.step);
            };
            cleanCheckout.steps.initStep(step);
        },
        initStep(step) {
            if (step == 2) {
                cleanCheckout.forms.copyFirstAndLastNameToPage2();
                var id = cleanCheckout.payment.paymentMethod;
                let paymentMethod = id ?
                    id :
                    Cookies.get('checkoutOption_payment');
                var url =
                    '/myty/api/crowdfunding/getStripeElements' +
                    '?payment_method=' + paymentMethod +
                    '&project=' + project.id;
                if (!paymentMethod) cleanCheckout.steps.show(1);
                else
                    $('#stripe_elements').load(url, null,
                        function() {
                            $(this).removeClass('skeleton-loader');
                        });
            }
        },
        show: function(step) {
            $('.js-step:visible').fadeOut('fast', function() {
                $('.js-step[data-step=' + step + ']').
                    hide().
                    removeClass('d-none').
                    fadeIn('fast');
                var postfix = (step == 2) ? 'a' : ''; // page2 is actually page2a
                projectPage.checkout.trackCheckoutEvents(
                    `checkout_page_${step + postfix}`);
            });
            cleanCheckout.steps.initStep(step);
        },
        getCurStep: function() {
            const params = new URLSearchParams(location.search);
            return parseInt(params.get('step'));
        },
    },
    forms: {
        init: function() {
            $('.js-free-amount').focus(function() {
                if (parseFloat($(this).val()) == 0) {
                    $(this).val('');
                }
            }).blur(function() {
                if ($(this).val() === '') {
                    $(this).val(utils.price.convertToString(0));
                }
            });

            $('[name="firstname"], [name="lastname"]').on('blur', function() {
                if (Cookies.get('checkoutOption_payment')) {
                    cleanCheckout.payment.toggleBtns();
                }
            });

            var $billAdress2b = $('.js-bill-address-2b');
            if ($billAdress2b.length) {
                projectPage.checkout.trackCheckoutEvents('checkout_page_2b');
                cleanCheckout.forms.check2b();
                $billAdress2b.find('.mytyFormControl').on('input', function() {
                    cleanCheckout.forms.check2b();
                });
            }
        },
        initDeliveryToggle: function() {
            $('.js-delivery-toggle').click(function(event) {
                event.preventDefault();
                $('.js-delivery-address').slideToggle('fast');
                $('#delivery-use').
                    prop('checked', !$('#delivery-use').prop('checked'));
                $(this).find('.js-icon').toggleClass('icon--flip-h');
            });
        },

        checkStep1: function() {
            const step1Error = $('.js-step1-error-msg');
            if (reward.select.checkOptions() |
                !cleanCheckout.forms.validateForm($('.js-user-data')) |
                !cleanCheckout.forms.checkPaymentSelect() |
                !projectPage.checkout.guestdata.checkEmails()) {
                step1Error.removeClass('d-none');
                $('.js-pay-btn .btn').addClass('is-disabled');
                projectPage.checkout.guestdata.validateEmailInputFinal();
                return false;
            } else {
                // data is valid
                step1Error.addClass('d-none');
                $('.js-pay-btn .btn').removeClass('is-disabled');
                projectPage.checkout.guestdata.validateEmailInputFinal();
                return true;
            }
        },

        checkPaymentSelect: function() {
            const isValid = !!$('[name="payment"]:checked').val();
            $('.js-pay-methods').toggleClass('has-error', !isValid);
            return isValid;
        },

        check2b: function() {
            $('.js-2b-submit').attr('disabled',
                !cleanCheckout.forms.validateForm($('.js-bill-address-2b')));
        },

        validateForm($form) {
            var valid = true;
            var movedFocus = false;
            $form.find('.mytyFormControl.mytyFormRequired:visible').
                each(function(i, e) {
                    const $input = $(this);
                    const $parent = $input.closest('.mytyFormBox');
                    $parent.removeClass('mytyFormError');
                    if (!$.trim($input.val()) ||
                        ($input.attr('name') == 'email' &&
                            !utils.isEmail($input.val()))) {
                        valid = false;
                        $parent.addClass('mytyFormError');
                        if (!movedFocus) {
                            $input.trigger('focus');
                            movedFocus = true;
                        }
                    }
                });
            return valid;
        },

        copyFirstAndLastNameToPage2() {
            projectPage.checkout.guestdata.setAddressField.call(
                $('input[name="firstname"]'));
            projectPage.checkout.guestdata.setAddressField.call(
                $('input[name="lastname"]'));
        },
    },
    payment: {
        initSelect: function() {
            var savedPayment = Cookies.get('checkoutOption_payment');
            if ($('#radio-' + savedPayment + ':checked').length) {
                cleanCheckout.payment.toggleBtns(savedPayment);
            }
            $('input[name="payment"]').on('change', function() {
                $('#error-payment').hide();
                var id = $(this).attr('id').replace('radio-', '');
                cleanCheckout.payment.paymentMethod = id;
                Cookies.set('checkoutOption_payment', id,
                    { 'path': '/', 'secure': true });
                sessionStorage.setItem('checkoutOption_payment', id); // used for trackGA
                cleanCheckout.payment.toggleBtns(id);
            });
            $('.js-info-btn').on('click', function() {
                $(this).
                    closest('.js-payment').
                    find('.js-info').
                    slideToggle('fast');
            });
        },
        initPayBtnTracking() {
            $(document.body).on('click', '.js-stripe-btn > *', function() {
                cleanCheckout.payment.trackPayBtn(); // paypal, apay and gpay have own tracking in checkoutRequestSettings
            });
        },
        trackPayBtn() {
            projectPage.checkout.trackCheckoutEvents(
                'checkout_page_1_submitted');
        },
        toggleBtns: function(payId = Cookies.get('checkoutOption_payment')) {
            $('.js-checkout-submit-text, .js-apay-gpay-btn').addClass('d-none');
            $('.js-stripe-btn').removeClass('d-none');
            if (payId && cleanCheckout.forms.checkStep1() &&
                !$('.js-empty-checkout-msg').is(':visible')) {
                if (payId === 'stripe_apay' || payId === 'stripe_gpay') {
                    $('.js-apay-gpay-btn').removeClass('d-none');
                    $('.js-stripe-btn').addClass('d-none');
                } else {
                    $('.js-apay-gpay-btn').addClass('d-none');
                }
            } else {
                $('.js-apay-gpay-btn').addClass('d-none');
            }

            // text on page 2 submit btn
            const type = (payId == 'stripe_paypal') ? 'paypal' : 'default';
            $('.js-checkout-submit-text[data-type="' + type + '"]').
                removeClass('d-none');
        },
        stripeElementValidation() {
            // absichtlich leer, wird von crowdfunding/mvc/view/payment/*.tpl überschrieben
        },
        sendCheckoutErrorToBackend(errorFromConfirm) {
            if (errorFromConfirm.message.indexOf('_') >= 0
                || errorFromConfirm.message.indexOf('[') >= 0
                || errorFromConfirm.message.indexOf(']') >= 0)
                $.post(
                    '/tycon/modules/crowdfunding/mvc/controller/ajax/checkout/request.php',
                    {
                        errorFromConfirm,
                        url: location.href,
                        action: 'logError',
                    },
                );
        },
        initializeStripePayments(cartTotal) {
            const stripeVars = $('#payment_methods stripeVars');
            if (typeof Stripe == 'undefined' || !stripeVars.length ||
                !stripeVars.data('public-api-key')) return;
            const stripe = Stripe(stripeVars.data('public-api-key'), {
                locale: stripeVars.data('locale'),
                apiVersion: stripeVars.data('api-version'),
            });
            cleanCheckout.payment.stripe = stripe;
            const elements = stripe.elements();

            cleanCheckout.paymentRequestOptions = {
                country: 'DE',
                currency: stripeVars.data('currency'),
                total: {
                    label: 'Total',
                    amount: Math.round(cartTotal * 100),
                },
            };
            const options = $.extend({}, cleanCheckout.paymentRequestOptions, {
                // @todo this can be !!stripeVars.data('request-shipping'), but we need to ask for less on page 2b.
                requestPayerName: true,
                requestShipping: true,
            });
            cleanCheckout.paymentRequest = stripe.paymentRequest(options);
            const paymentRequest = cleanCheckout.paymentRequest;
            let paymentType;

            (async () => {
                // Check the availability of the Payment Request API first.
                const result = await paymentRequest.canMakePayment();
                if (result) {
                    const prButton = elements.create('paymentRequestButton',
                        { paymentRequest });
                    prButton.mount('.js-apay-gpay-btn');
                    prButton.on('click', function(event) {
                        if (!cleanCheckout.forms.checkStep1()) event.preventDefault();
                    });
                    if (result.applePay) {
                        paymentType = 'stripe_apay';
                    }
                    if (result.googlePay) {
                        paymentType = 'stripe_gpay';
                    }
                    if (paymentType) {
                        $('label[for=radio-' + paymentType + ']').
                            removeClass('d-none');
                    }
                }
            })();

            /**
             * @param {StripePaymentMethodPaymentResponse} event
             */
            function saveAddressFromEventToForm(event) {
                // nur für ApplePay/GPay
                var address = event.shippingAddress;
                if (address.city) {
                    $('[name="delivery_city"], [name="bill_city"]').
                        val(address.city);
                }
                if (address.postalCode) {
                    $('[name="delivery_zip"], [name="bill_zip"]').
                        val(address.postalCode);
                }
                const street = address.addressLine.join(', ');
                if (street) {
                    $('[name="delivery_address"], [name="bill_address"]').
                        val(street);
                }
                if (address.country) {
                    $('[name="delivery_country"], [name="bill_country"]').
                        val(address.country);
                }
                if (address.recipient) {
                    var nameParts = address.recipient.split(' ');
                    $('[name="delivery_firstname"], [name="bill_firstname"]').
                        val(nameParts.shift());
                    $('[name="delivery_lastname"], [name="bill_lastname"]').
                        val(nameParts.join(' '));
                } else {
                    // Der shippingaddresschange-Event liefert uns keinen Namen
                    cleanCheckout.forms.copyFirstAndLastNameToPage2();
                }
            }

            paymentRequest.on('shippingaddresschange', function(event) {
                saveAddressFromEventToForm(event);
                event.updateWith({
                    status: 'success',
                    shippingOptions: [{ id: 'null', amount: 0, label: '' }],
                });
            });

            paymentRequest.on('paymentmethod', async function(ev) {
                saveAddressFromEventToForm(ev);
                // Der Nutzer hat die Zahlung mit Apple Pay/GPay in deren Overlay bestätigt
                ev.getAdditionalSuccessParams = function() {
                    return '' +
                        '&paymentType=' + paymentType +
                        '&last4=' + ev.paymentMethod.card.last4 +
                        '&paymentMethodId=' + ev.setupIntent.payment_method;
                };
                const jqXHR = cleanCheckout.payment.submitCheckout(ev);
                jqXHR.done(() => cleanCheckout.payment.stripeCapture(ev));
                jqXHR.fail(() => ev.complete('fail'));
            });
        },
        checkPaypalAbort() {
            const urlParams = new URLSearchParams(window.location.search);
            const paypalCanceled = Number(urlParams.get('paypal_canceled'));
            paypalCanceled === 1 ?
                $('.js-paypal-abort-msg').removeClass('d-none') :
                $('.js-paypal-abort-msg').addClass('d-none');
        },

        /**
         * Die Kreditkarte bei Stripe einreichen und schauen, ob wir sie an den Seti hängen können.
         * @param {PaymentResponse} ev
         */
        stripeCapture: async function(ev) {
            // Fill the Setup Intent with the new payment method from Apple Pay / Google Pay.
            const {
                setupIntent,
                confirmError,
            } = await cleanCheckout.payment.stripe.confirmCardSetup(
                ev.checkoutResponse.client_secret,
                { payment_method: ev.paymentMethod.id },
                { handleActions: false },
            );
            ev.setupIntent = setupIntent;
            if (confirmError) {
                // Report to the browser that the payment failed, prompting it to
                // re-show the payment interface, or show an error message and close
                // the payment interface.
                cleanCheckout.payment.sendCheckoutErrorToBackend(confirmError);
                ev.cardError.show();
                ev.complete('fail');
            } else {
                // Report to the browser that the confirmation was successful, prompting
                // it to close the browser payment method collection interface.
                ev.complete('success');
                cleanCheckout.payment.processWalletPaySuccess(ev);
            }
        },

        /**
         * Used by payment methods that have a page 2b:
         * Apple Pay and GPay
         * @param {PaymentResponse|object} ev
         * @returns {JQuery.jqXHR}
         */
        submitCheckout: function(ev) {
            ev.cardError = $('.js-checkout-error-msg').hide();
            const checkoutRequestSettings = {
                url: '/myty/api/crowdfunding/checkout',
                data: projectPage.form.serialize(),
                type: 'POST',
                dataType: 'json',
                error: function(response) {
                    utils.strToScope(projectPage.form.data('errorcallback'))(
                        response);
                    ev.cardError.show();
                },
                success: async function(checkoutResponse) {
                    ev.checkoutResponse = checkoutResponse;
                    if (!checkoutResponse.success) {
                        ev.cardError.html(checkoutResponse.message).show();
                        ev.cardError[0].scrollIntoView();
                        ev.complete('fail');
                    } else {
                        // track apay & gpay
                        projectPage.checkout.trackCheckoutEvents(
                            'checkout_page_1_submitted');
                    }
                },
            };
            return $.ajax(checkoutRequestSettings);
        },
        processWalletPaySuccess(ev) {
            $.ajax({
                url: '/myty/api/crowdfunding/processWalletPaySuccess' +
                    '?fundingId=' + ev.checkoutResponse.fundingId +
                    '&fundingHash=' +
                    encodeURIComponent(ev.checkoutResponse.fundingHash) +
                    '&newLanguage=' + ev.checkoutResponse.locale +
                    ev.getAdditionalSuccessParams(),
                type: 'POST',
                dataType: 'json',
                success: projectPage.checkout.handleResponse,
                error: projectPage.checkout.handleError,
            });
        },
    },
    cofundingPreview: {
        request: null,
        refresh: function(amount) {
            if ($('.js-cofunding-sum').length) {
                var url = '/templates/platforms/startnext/snippets/project/ajax.php',
                    data = {
                        //topic: myty.topic.id,
                        topic: tyState.topic, //deprecated, myty should be used
                        action: 'getCofundingPreview',
                        project: project.link_caption,
                        amount: amount,
                    };
                if (cleanCheckout.cofundingPreview.request != null) {
                    // cancel old running requests
                    cleanCheckout.cofundingPreview.request.abort();
                }
                cleanCheckout.cofundingPreview.request = $.getJSON(url, data,
                    function(result) {
                        if (result) {
                            $.each(result, function(key, val) {
                                $('[data-cid=' + key + '] .js-cofunding-sum').
                                    text(utils.price.convertToString(
                                        parseFloat(val), 2));
                            });
                        }
                    });
            }
        },
    },
    successPage: {
        scrollAnimation: async function() {
            await SystemJS.import('gsap');
            if (typeof gsap !== 'undefined') {
                await SystemJS.import('scroll-trigger');
                gsap.registerPlugin(ScrollTrigger);

                /**
                 * Separator Beans
                 */
                const beans = document.querySelectorAll(
                    '.js-bean-animation');
                if (beans.length > 0) {
                    beans.forEach((bean, index) => {
                        const dots = gsap.utils.toArray(
                            bean.querySelectorAll('.separator-bean__dot'));
                        const offset = beans[index].getBoundingClientRect();
                        const screenHeight = screen.height;
                        const startPos = screenHeight > offset.top ?
                            `${offset.top - 50 * index}px` :
                            'bottom';
                        const endPos = screenHeight > offset.top ?
                            `${offset.top - (screenHeight / 2)}` :
                            '50%';
                        const tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: bean,
                                start: `top ${startPos}`,
                                end: `bottom ${endPos}`,
                                scrub: .01,
                            },
                        });
                        gsap.set(dots, { left: 0 });
                        dots.reverse().forEach((dot) => {
                            tl.to(dot, {
                                left: 25,
                                delay: -0.3,
                            });
                        });
                    });
                }

                /**
                 * Animated Thanks Badge
                 */
                const badge = document.querySelector('.js-scroll-animation');
                if (badge) {
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: badge,
                            scrub: .1,
                            start: '-20px bottom',
                            end: 'top 75%',
                        },
                    });
                    tl.to(badge,
                        { left: `calc(100% - ${badge.offsetWidth}px)` });
                }
            }
        },
    },
};

var projectPage = {
    form: null,
    onReady: function() {
        var $appFundingProcess = $('#appFundingProcess');
        projectPage.form = $appFundingProcess.find('form');

        //DACH-Länder in Länder-Select nach vorne sortieren
        var $countrySelects = $appFundingProcess.find(
            'select[name="delivery_country"], select[name="bill_country"]');
        if ($countrySelects.length) {
            $countrySelects.each(function() {
                var $countrySelect = $(this);
                var $optionsToMove = $countrySelect.children(
                    '[value=\'Deutschland\'],[value=\'Österreich\'],[value=\'Schweiz\'],[value=\'Germany\'],[value=\'Austria\'],[value=\'Switzerland\']');
                var $emptyOption = $countrySelect.children('[value=""]');
                if ($emptyOption.length) $optionsToMove.insertAfter(
                    $emptyOption);
                else $optionsToMove.prependTo($countrySelect);

                //DE in Länderselect auswählen, wenn noch kein Land im DOM gewählt wurde
                if ($countrySelect.children('[selected]').length === 0) {
                    var gerStr = 'Deutschland';
                    var $de = $countrySelect.children(
                        '[value=\'' + gerStr + '\']');
                    if (!$de.length) {
                        gerStr = 'Germany';
                        $de = $countrySelect.children(
                            '[value=\'' + gerStr + '\']');
                    }
                    if ($de.length) $countrySelect.val(gerStr);
                }
            });
        }

        $('.js-logout').on('click', async function(event) {
            event.preventDefault();

            // delete all cfCard_cust_* cookies
            $.each(document.cookie.split(/; */), function() {
                var splitCookie = this.split('=');
                Cookies.remove(splitCookie[0], '/');
            });
            $.ajax('/?logout=1').done(function() {
                document.location.reload();
            });
        });

        // set checkout-options (checkboxes, etc.)
        $('#appFundingProcess :checkbox[data-role=option],#appFundingProcess :radio[data-role=option]').
            click(function() {
                projectPage.checkout.setOption.call(this,
                    (this.checked ? $(this).val() : null));
            });
        $appFundingProcess.find(':input[data-role=quantity]').
            change(function() {
                projectPage.checkout.setQuantity.call(this, $(this).val());
            });
        $appFundingProcess.find(':input[data-role=option]').change(function() {
            projectPage.checkout.setOption.call(this, $(this).val());
        });
        $appFundingProcess.find(':input[data-role=freeAmount]').
            change(function() {
                projectPage.checkout.updateFreeAmount.call(this, $(this).val());
            });

        $('#page-2a-submit').on('click', async function(event) {
            // additional function to control submit of event

            var billValid = cleanCheckout.forms.validateForm(
                $('.js-bill-address'));
            var deliveryValid = $('.js-delivery-address').length == 0 ||
                !$('#delivery-use').prop('checked') ||
                cleanCheckout.forms.validateForm($('.js-delivery-address'));
            var stripeValid = $('#stripe_elements').hasClass('d-none') ||
                await cleanCheckout.payment.stripeElementValidation(event) !==
                false;

            if (billValid && deliveryValid && stripeValid &&
                (projectPage.checkout.onSubmit(event, projectPage.form) !==
                    false))
                projectPage.form.submit();
        });

        if ($('.js-guestdata').length) {
            projectPage.checkout.guestdata.init.apply(this);
        }

        if ($('.js-delivery-address').length) {
            projectPage.checkout.delivery.init.apply(this);
        }

        if ($('.js-bill-address').length) {
            projectPage.checkout.bill.init.apply(this);
        }

        projectPage.checkout.refreshCart.apply(this, [true]);

        // Track Checkout opened
        if ($appFundingProcess.not('.js-checkout-2b').length) {
            // set payment for tracking
            if (Cookies.get('checkoutOption_payment')) {
                sessionStorage.setItem('checkoutOption_payment',
                    Cookies.get('checkoutOption_payment'));
            } else {
                sessionStorage.removeItem('checkoutOption_payment');
            }
            projectPage.checkout.trackCheckoutEvents('enter_checkout');
        }
    },
    checkout: {
        // set boolean option (checked)
        setOption: function(value) {
            var name = $(this).attr('name');
            if (name.indexOf('[') > 0) {
                name = name.replace(/\[/g, '_').replace(/\]/g, '');
            }
            if (value) {
                Cookies.set('checkoutOption_' + name, value,
                    { 'path': project.path, 'secure': true });
            } else {
                Cookies.remove('checkoutOption_' + name,
                    { 'path': project.path, 'secure': true });
            }
        },
        setQuantity: function(newQuantity) {
            var value = parseInt(newQuantity),
                name = $(this).attr('name'),
                id = $(this).attr('data-id'),
                amountWrap = $('[data-reward-id=' + id + '] .js-amount-wrap'),
                amountElmnt = amountWrap.find('.js-amount'),
                max = parseInt($(this).attr('max'));
            if (name.indexOf('[') > 0) {
                name = name.replace(/\[/g, '_').replace(/\]/g, '');
            }
            var position = cartPositions[$(this).attr('data-id')];
            if (position.maxQuantity > 0) {
                value = Math.min(position.available, value);
            }
            value = Math.max(0, value);
            $(this).closest('.mytyFormBox').removeClass('mytyFormError');
            $('.js-reward-error[data-reward=' + id + ']').addClass('d-none');
            if (value == 0) {
                projectPage.checkout.removeItem(id);
                return false;
            } else if (value > max) {
                $('.js-reward-error[data-reward=' + id + ']').
                    removeClass('d-none');
                $(this).closest('.mytyFormBox').addClass('mytyFormError');
                return false;
            }
            $(this).val(value);
            projectPage.checkout.refreshCart.call(this);
            amountElmnt.text(value);
            if (value != 1) {
                amountWrap.removeClass('hidden d-none');
            } else {
                amountWrap.addClass('hidden d-none');
            }
            projectPage.checkout.updateIncentiveToBasket(id, value);
        },
        removeItem: function(posId) {
            var name = cartPositions[posId].type;
            if (posId != name) name += '_' + posId;
            if (typeof cartPositions[posId] !=
                'undefined') delete cartPositions[posId];

            $('.js-reward[data-id=' + posId + '], [data-reward-id=' + posId +
                ']').slideUp('fast', function() {
                $(this).remove();
                projectPage.checkout.refreshCart.call(this);
            });
            projectPage.checkout.updateIncentiveToBasket(posId, 0);
        },
        updateFreeAmount: function() {
            var posId = $(this).attr('data-id');
            var value = parseFloat(utils.price.convertToNumber($(this).val()));

            if (isNaN(value)) value = 0;
            if (value <= 0) {
                $(this).val(value = parseFloat(utils.price.convertToString(0)));
                cartPositions[posId]['price'] = 0;
                $('.js-free-amount').text('0,00');
                $('.js-free-amount-row').addClass('hidden d-none');
            } else {
                $(this).val(utils.price.convertToString(value * 1));
                if (!(posId in cartPositions)) {
                    cartPositions[posId] = {
                        incentiveType: '',
                        price: value,
                        type: posId,
                    };
                } else {
                    cartPositions[posId]['price'] = value;
                }
                nlytcs.trackCartUpdates(cartPositions);
                $('.js-free-amount').
                    text(utils.price.convertToString(value, 2));
                $('.js-free-amount-row').removeClass('hidden d-none');
            }

            projectPage.checkout.refreshCart.call(this);
            var basketData = {};
            basketData['free_amount'] = value;
            projectPage.checkout.updateBasket(basketData);
        },
        updateIncentiveToBasket: function(elId, quantity, fwdUrl) {
            let basketData = {};
            let incentiveId = elId;
            if (elId.indexOf('-') > -1) {
                let incentiveParts = elId.split('-');
                //at second position is id of incentive
                incentiveId = incentiveParts[1];
            }
            basketData['incentive_id'] = parseInt(incentiveId);
            basketData['quantity'] = quantity;

            if ($('#freeoption' + elId).length) {
                basketData['freeoption'] = $('#freeoption' + elId).val();
            }
            if ($('#freeoption2' + elId).length) {
                basketData['freeoption2'] = $('#freeoption2' + elId).val();
            }
            if ($('#freeoption3' + elId).length) {
                basketData['freeoption3'] = $('#freeoption3' + elId).val();
            }

            projectPage.checkout.updateBasket(basketData, fwdUrl);
        },
        basketRequest: null,
        updateBasket: function(basketData, fwdUrl) {
            if (projectPage.checkout.basketRequest) projectPage.checkout.basketRequest.abort();
            projectPage.checkout.basketRequest = $.ajax({
                'url': '/myty/api/crowdfunding/project/' +
                    project.link_caption + '/updateBasket',
                'data': basketData,
                'dataType': 'json',
                'type': 'POST',
                'success': function(response) {
                    projectPage.checkout.basketRequest = null;
                    projectPage.checkout.sendRefreshEvent();
                    if (fwdUrl) document.location.href = fwdUrl;

                    // Update cartPositions in project.clean.checkout.tpl
                    if (typeof cartPositions !== 'undefined') {
                        if (typeof cartPositions[`${project.id}-${basketData.incentive_id}`] !==
                            'undefined') {
                            cartPositions[`${project.id}-${basketData.incentive_id}`].quantity = basketData.quantity;
                        }
                        nlytcs.trackCartUpdates(cartPositions);
                    }
                },
            });
        },
        sendRefreshEvent() {
            //Summe an Vue-App Ratenzahlungsauswahl übergeben
            const amount = parseFloat(
                utils.price.convertToNumber($('.js-cart-sum').first().text(),
                    2));
            const refreshTotalEvent = new CustomEvent(
                'refreshTotal',
                {
                    detail: {
                        fundingAmount: parseFloat(
                            $('[name="fundingAmount"]').val()),
                        total: amount,
                    },
                });
            window.dispatchEvent(refreshTotalEvent);
        },
        refreshCart: function(init) {
            var posSum = 0, posQty = 0, cartSum = 0, cartTotal = 0;
            //warenkorbpositionen zusammenrechnen
            if (typeof cartPositions !== 'undefined') {
                $.each(cartPositions, function(k) {
                    if (k === 'pwyw') return;
                    posQty = $(
                        '#appFundingProcess input[data-role=quantity][data-id=' +
                        k + '],select[data-role=quantity][data-id=' + k + ']').
                        val();
                    if (posQty) {
                        posQty = Math.max(0, parseInt(posQty));
                    } else {
                        posQty = 1;
                    }

                    posSum = (cartPositions[k].price * posQty);
                    $('#priceSum-' + k).
                        text(utils.price.convertToString(posSum, 2));
                    cartSum += posSum;
                    cartTotal += posSum;
                });
            }
            cartTotal = window.utils.price.fixFloatingPoint(cartTotal);

            // Cofunding-Vorschau aktualisieren, falls sich Summe geändert hat
            if ($('.js-cart-sum').length &&
                parseFloat($('[name=fundingAmount]').val()) != cartTotal) {
                cleanCheckout.cofundingPreview.refresh(cartTotal);
            }

            //Plattformspende dazu rechnen
            var $donationAmountInput = $('#donationAmountInput');
            var platformDonation = $donationAmountInput.val() || 0;
            if ($.isNumeric(platformDonation)) {
                platformDonation = parseFloat(platformDonation);
                cartTotal += platformDonation;
            }
            cartTotal = window.utils.price.fixFloatingPoint(cartTotal);

            //Anzeige Gesamtsumme
            $('.js-cart-sum').text(utils.price.convertToString(cartTotal, 2));

            // Formularfelder aktualisieren
            $('#appFundingProcess [name=fundingAmount]').val(cartSum);
            $('#appFundingProcess [name=cartSum]').val(cartTotal);

            //Zahlungsart validieren
            $('.js-payment').each(function(index, element) {
                //min-max prüfen
                if (typeof $(this).attr('data-min') !== 'undefined'
                    && typeof $(this).attr('data-max') !== 'undefined') {
                    var min = parseInt($(this).attr('data-min'));
                    var max = parseInt($(this).attr('data-max'));
                    //contains: free amount + incentives + pwyw
                    if (cartTotal < min || cartTotal > max) {
                        $(this).
                            addClass('is-disabled').
                            find('input').
                            attr('disabled', 'disabled');
                    } else {
                        $(this).
                            removeClass('is-disabled').
                            find('input').
                            removeAttr('disabled');
                    }
                }
            });

            // Meldung "Warenkorb leer" ein-/ausblenden, weiter-Button sperren/entsperren
            var emptyMsg = $('.js-empty-checkout-msg');
            if (cartTotal == 0) {
                emptyMsg.removeClass('d-none');
            } else {
                emptyMsg.addClass('d-none');
            }

            // Meldung "min/max" ein-/ausblenden, weiter-Button sperren/entsperren
            var minAmount = 9999999,
                maxAmount = 0,
                minMsg = $('.js-min-amount-msg'),
                minMsgTxt = minMsg.find('p'),
                maxMsg = $('.js-max-amount-msg'),
                currency = $('.js-project-currency').text().trim();
            $('.js-payment').each(function(i, e) {
                var thisMin = parseInt($(this).attr('data-min')),
                    thisMax = parseInt($(this).attr('data-max'));
                if (thisMin < minAmount) minAmount = thisMin;
                if (thisMax > maxAmount) maxAmount = thisMax;
            });

            minMsgTxt.text(minMsgTxt.text().
                replace('%currency%', currency).
                replace('%min%', minAmount));
            maxMsg.text(maxMsg.text().
                replace('%currency%', currency).
                replace('%max%', utils.price.convertToString(maxAmount, 0)));

            if (cartTotal < minAmount && cartTotal > 0) {
                minMsg.removeClass('d-none');
                $('.js-free-amount').addClass('has-error');
            } else {
                minMsg.addClass('d-none');
                $('.js-free-amount').removeClass('has-error');
            }
            if (cartTotal > maxAmount) {
                maxMsg.removeClass('d-none');
            } else {
                maxMsg.addClass('d-none');
            }
            cleanCheckout.cartTotal = cartTotal;
            if (init) {
                cleanCheckout.payment.stripeScriptPromise.done(
                    () => cleanCheckout.payment.initializeStripePayments(
                        cartTotal));
            } else {
                const walletPayOptions = cleanCheckout.paymentRequestOptions;
                if (walletPayOptions) {
                    walletPayOptions.total.amount = cartTotal * 100;
                    cleanCheckout.paymentRequest.update(walletPayOptions);
                }
            }
        },
        bill: {
            init: function() {
                $('.js-bill-address :input[type!="hidden"]').change(
                    function() {
                        projectPage.checkout.bill.setAddressField.call(this);
                    },
                );

                projectPage.checkout.bill.initForm.apply(this, arguments);
                projectPage.checkout.bill.toggleBday();
                $('[name="bill_country"], #amount-donation_amount').
                    change(function() {
                        projectPage.checkout.bill.toggleBday();
                    });
            },
            setAddressField: function() {
                var name = 'cfCart_cust_' + $(this).attr('name');
                Cookies.set(name, $(this).val(),
                    { 'path': '/', 'secure': true });
            },
            getAddressField: function(name) {
                name = 'cfCart_cust_' + name;
                return Cookies.get(name);
            },
            initForm: function() {
                if ($('[name=fundingAmount]').val() === '0' &&
                    location.search === '?step=2') {
                    // Cart is empty; send supporter back to previous page where
                    // cart can be filled.
                    location.href = location.pathname;
                }
                var fields = $('.js-bill-address :input[type!="hidden"]');
                if (fields.length > 0) {
                    var value;
                    fields.each(function(i) {
                        value = projectPage.checkout.bill.getAddressField(
                            $(this).attr('name'));
                        if (value !== null && value != '' && typeof value !==
                            'undefined') {
                            if ($(this).is(':radio,:checkbox')) {
                                if (value == $(this).val()) {
                                    $(this).
                                        attr('checked', 'checked').
                                        trigger('change');
                                }
                            } else if (value != $(this).val()) {
                                $(this).val(value);
                            }
                        }
                    });
                }
            },
            toggleBday: function() {
                // Feld einblenden, wenn: Projektland AT, Rechungsadresse AT, Spende > 0
                var bdayRequired = ($('.js-bill-address').
                        hasClass('js-donation-possible') &&
                    parseFloat($('#amount-donation_amount').val()) > 0 &&
                    projectPage.checkout.bill.isAustria(
                        $('[name="bill_country"]').val()) &&
                    projectPage.checkout.bill.isAustria(
                        $('.js-bill-address').attr('data-project-country')));
                if (bdayRequired) {
                    $('.js-bill-birthday').
                        removeClass('d-none').
                        addClass('mytyFormRequired').
                        find('input').
                        addClass('mytyFormRequired').
                        prop('required', true);
                } else {
                    $('.js-bill-birthday').
                        addClass('d-none').
                        removeClass('mytyFormRequired').
                        find('input').
                        removeClass('mytyFormRequired').
                        prop('required', false);
                }
            },
            isAustria: function(country) {
                country = country.toLowerCase();
                return (country == 'österreich' || country == 'austria' ||
                    country == 'autriche');
            },
        },
        delivery: {
            init: function() {
                const deliveryAddressIsNotIdenticalToBillingCheckbox = $(
                    '#delivery-use');
                deliveryAddressIsNotIdenticalToBillingCheckbox.on('change',
                    function() {
                        $('.js-delivery-address').toggle();
                        $('.js-header-bill').toggle();
                        $('.js-header-delivery-bill').toggle();
                    });
                if (deliveryAddressIsNotIdenticalToBillingCheckbox.prop(
                    'checked')) {
                    deliveryAddressIsNotIdenticalToBillingCheckbox.trigger(
                        'change');
                }
                $('.js-delivery-address :input[type!="hidden"]').
                    change(function() {
                        projectPage.checkout.delivery.setAddressField.call(
                            this);
                    });
                projectPage.checkout.delivery.initForm.apply(this, arguments);
            },
            setAddressField: function() {
                var name = 'cfCart_cust_' + $(this).attr('name');
                Cookies.set(name, $(this).val(),
                    { 'path': '/', 'secure': true });
            },
            getAddressField: function(name) {
                name = 'cfCart_cust_' + name;
                return Cookies.get(name);
            },
            initForm: function() {
                var fields = $('.js-delivery-address :input[type!="hidden"]');
                if (fields.length > 0) {
                    var value;
                    fields.each(function(i) {
                        value = projectPage.checkout.delivery.getAddressField(
                            $(this).attr('name'));
                        if (value !== null && value != '' && typeof value !==
                            'undefined') {
                            if ($(this).is(':radio,:checkbox')) {
                                if (value == $(this).val()) {
                                    $(this).trigger('change');
                                }
                            } else if (value != $(this).val()) {
                                $(this).val(value);
                            }
                        }
                    });
                }
            },
        },
        guestdata: {
            cookieNamePrefix: 'cfCart_cust_',
            cookieNamePasswordRequired: 'require-pwd',

            init: function() {
                $('.js-guestdata :input[type!="hidden"]').change(function() {
                    projectPage.checkout.guestdata.setAddressField.call(this);
                });

                var inputTimeout = null;
                var oldVal = null;
                var email = $('.js-guestdata :input[name=email]');
                var emailValidation = $(
                    '.js-guestdata :input[name=email_validation]');
                email.on('input keyup propertychange', function() {
                    var val = $.trim(this.value);
                    if (val === oldVal) return false; //kein ajax-call, wenn Wert sich nicht verändert hat
                    oldVal = val;
                    if (inputTimeout) clearTimeout(inputTimeout);
                    var that = this;
                    inputTimeout = setTimeout(function() { //timeout setzen, damit nicht nach jedem change ge-ajaxt wird
                        projectPage.checkout.guestdata.setAddressField.call(
                            that);
                    }, 300);
                });
                emailValidation.on('input', function() {
                    projectPage.checkout.guestdata.setAddressField.call(
                        $(this));
                });
                emailValidation.on('blur', function() {
                    projectPage.checkout.guestdata.validateEmailInputFinal();
                    if (Cookies.get('checkoutOption_payment'))
                        cleanCheckout.payment.toggleBtns();
                });
                // check if we have to show the password field on page load
                projectPage.checkout.guestdata.setAddressField.call(email);
                $('input').on('keydown', function(event) {
                    if (event.key === 'Enter') $('.btn-primary:visible').
                        trigger('click');
                });

                projectPage.checkout.guestdata.initForm.apply(this, arguments);
            },
            setAddressField: function() {
                var node = $(this),
                    fieldName = node.attr('name'),
                    name = projectPage.checkout.guestdata.cookieNamePrefix +
                        fieldName;

                if ('password' != node.attr('type')) {
                    Cookies.set(name, node.val(),
                        { 'path': '/', 'secure': true });
                }

                if ('email' === fieldName) {
                    projectPage.checkout.guestdata.validateEmailInput(this);
                }

                if ('email_validation' === fieldName) {
                    projectPage.checkout.guestdata.validateEmailValidationInput(
                        this);
                }

                // add to form on step 2
                var selector = '#checkout___rechnungsadresse ' +
                    'input[name="bill_' + fieldName + '"], ' +
                    'input[name="delivery_' + fieldName + '"]';
                $(selector).val(node.val()).trigger('change');
            },
            getAddressField: function(name) {
                name = projectPage.checkout.guestdata.cookieNamePrefix + name;
                return Cookies.get(name);
            },
            initForm: function() {
                var fields = $('.js-guestdata :input[type!="hidden"]');
                if (fields.length > 0) {
                    var value;
                    fields.each(function(i) {
                        var node = $(this),
                            type = node.attr('type');
                        value = projectPage.checkout.guestdata.getAddressField(
                            node.attr('name'));

                        if (value !== null) {
                            if (node.is(':radio,:checkbox') && value != '') {
                                if (value == node.val()) {
                                    node.trigger('change');
                                }
                            } else if ('password' !== type) {
                                if (value != '' && value != node.val()) {
                                    node.val(utils.unescape(value));
                                }
                            }
                        }

                        // set readonly if logged in
                        if (typeof window.userSession != 'undefined') node.attr(
                            'readonly', 1);
                    });
                }
            },

            /**
             * @param {boolean} showPassword
             */
            toggleLoginMsg: function(hide) {
                $('.js-email-exists-msg').toggleClass('d-none', !hide);
                if (typeof userSession != 'undefined') hide = true; // hide email_validation if logged in
                $('.js-user-data input[name="email_validation"]').
                    closest('.mytyFormBox').
                    toggleClass('hidden', hide);
            },
            validateEmailInput: function(inputNode) {
                if (!projectPage.form) projectPage.onReady();
                var form = projectPage.form,
                    input = $(inputNode),
                    email = $.trim(input.val());

                if (email.length > 0 && email.indexOf('@') !== -1) {

                    $.ajax({
                        'url': form.attr('action'),
                        'data': { action: 'validateEmailInput', email: email },
                        'dataType': 'json',
                        'type': 'post',
                        'success': function(response) {
                            projectPage.checkout.guestdata.toggleLoginMsg(
                                response.status == 401 || response.status ==
                                402);
                        },
                        'error': projectPage.form.attr('data-errorcallback'),
                    });
                } else {
                    projectPage.checkout.guestdata.toggleLoginMsg(false);
                }
            },
            validateEmailValidationInput: function(inputNode) {
                //check if email contains email_validation
                if (!projectPage.form) projectPage.onReady();
                var input = $(inputNode),
                    email_validation = $.trim(input.val());

                if (email_validation.length > 0) {
                    var email = $.trim(
                        $('.js-guestdata').find('input[name="email"]').val(),
                    );

                    if (email.indexOf(email_validation) !== 0) {
                        //show error
                        input.closest('.mytyFormBox').addClass('mytyFormError');
                    } else {
                        input.closest('.mytyFormBox').
                            removeClass('mytyFormError');
                    }

                }
            },
            validateEmailInputFinal: function() {
                // check if emails identical
                if (!projectPage.checkout.guestdata.checkEmails()) {
                    $('.js-user-data input[name=email_validation]').
                        closest('.mytyFormBox').
                        addClass('mytyFormError');
                }
            },
            checkEmails: function() {
                const firstVal = $('.js-user-data input[name=email]').
                    val().
                    trim();
                const secondVal = $(
                    '.js-user-data input[name=email_validation]').val().trim();
                return (typeof window.userSession != 'undefined' || (firstVal ==
                    secondVal && firstVal != '' && secondVal != ''));
            },
        },
        handleResponse: function(response) {
            if (response.success && response.redirectUrl) {
                if (cleanCheckout.steps.getCurStep() == 2) {
                    projectPage.checkout.trackCheckoutEvents(
                        'checkout_page_2a_submit_success');
                }

                // Redirects to Stripe/PayPal if we set up a new Stripe payment method with the type PayPal
                if (response.payment_method === 'stripe_paypal' &&
                    response.redirect_to_stripe === true) {
                    cleanCheckout.payment.stripe.confirmPayPalSetup(
                        response.client_secret,
                        {
                            return_url: response.redirectUrl,
                            mandate_data: {
                                customer_acceptance: {
                                    type: 'online',
                                    online: {
                                        infer_from_client: true,
                                    },
                                },
                            },
                        },
                    );
                    return;
                }

                location.href = response.redirectUrl;
            } else {
                projectPage.checkout.handleError.call(this, response);
            }
        },
        handleError: function(response) {
            if (cleanCheckout.steps.getCurStep() == 2) {
                projectPage.checkout.trackCheckoutEvents(
                    'checkout_page_2a_submit_error');
                if (newrelic) newrelic.noticeError(
                    new Error('Checkout Page 2a Submit Error'),
                    { response: response });
            }

            var message = response.message || 'unexpected error occurred',
                showGeneralError = true;

            // error: payment not available
            if (response.errorFields && response.errorFields.length) {
                if ((response.errorFields[0] === 'payment'
                        && response.params
                        && response.params.payment !== ''
                        && !$('.js-payment.is-disabled.is-active').length)
                    || response.content === 'false') {
                    message = $('[data-pay-errortxt]').
                        attr('data-pay-errortxt');
                } else if (response.errorFields[0].substr(0, 10) ==
                    'incentive[') {
                    // reward overbooked
                    var id = response.errorFields[0].replace('incentive[', '').
                        replace(']', '');
                    projectPage.checkout.removeItem(id);
                    cleanCheckout.steps.show(1);
                } else {
                    $('#appFundingProcess .mytyFormError').
                        removeClass('mytyFormError'); // clear old
                    var firstErrorField = null;

                    $.each(response.errorFields, function(key, name) {
                        orgName = name;
                        name = name.replace(/^user_/, '').
                            replace(/[^a-z0-9-_]/g, '');
                        var errorField = $('#error-' + name);
                        if (errorField.length > 0) {
                            showGeneralError = false;
                            if (key === 0) {
                                firstErrorField = errorField;
                            }
                            errorField.html(message).fadeIn('fast');
                        }
                        $('#appFundingProcess form :input[name="' + orgName +
                            '"]').
                            addClass('mytyFormError').
                            parents('.mytyFormBox').
                            addClass('mytyFormError');
                    });

                    var headbarHeight = $('.headbar').height();
                    if ($('.mytyFormError').closest('[data-step="1"]').length) {
                        // ggf. Seite 1 zeigen
                        cleanCheckout.steps.show(1);
                    } else if (firstErrorField !== null) {
                        var $firstErrorField = firstErrorField.closest(
                            'fieldset');
                        if ($firstErrorField.length === 0) {
                            $firstErrorField = firstErrorField;
                        }
                    }
                }
            }

            // show message above form
            if (showGeneralError) {
                const $errorMessage = $('.js-checkout-error-msg');
                if ($errorMessage.length) {
                    $errorMessage.hide().fadeIn('fast').find('p').html(message); // force re-entry
                } else {
                    alert(message);
                }
            }

            $('.js-checkout-submit').show(); // This refers to '.js-checkout-submit'
            $('#appFundingProcess .loader').addClass('d-none');
        },
        /**
         * Prevent submit if birthday/terms not checked.
         * Show Loader till payment overlay loads.
         * @param {MouseEvent} event
         * @param {jQuery} form
         */
        onSubmit: function(event, form) {
            var mail = $(
                'input[name="email"]:visible, input[name="email_validation"]:visible');
            var bday = $('.js-bill-birthday');
            if (bday.is(':visible') && !bday.find('input').val()) {
                bday.addClass('mytyFormError');
                return false;
            }
            if (mail.length === 2 &&
                (!mail[0].value || mail[0].value != mail[1].value)) {
                mail.addClass('mytyFormError');
                return false;
            }

            bday.removeClass('mytyFormError');
            mail.removeClass('mytyFormError');
            form.find('.js-checkout-submit').hide(); // This refers to '.js-checkout-submit'
            form.find('.loader').removeClass('d-none');
        },
        trackCheckoutEvents: function(action) {
            nlytcs.matomoTrackEvent(
                'trackEvent',
                'checkout', // Category (required)
                action, // Action (required)
                sessionStorage.getItem('checkoutOption_payment') !== null ?
                    sessionStorage.getItem('checkoutOption_payment') :
                    'Es wurde noch keine Bezahloption ausgewählt', // Name: always send chosen payment method if set (optional)
            );
        },
    },
};

$(function() {
    cleanCheckout.init();
    projectPage.onReady.apply(this, arguments);
    projectPage.checkout.sendRefreshEvent();
});

window.sendRefreshEvent = projectPage.checkout.sendRefreshEvent; // split-payments.vue && PwywSupporter.vue
